import { ChannelMessageHandler, ChannelReadyHandler } from './message-channel-wrapper'

export interface BaseChannelMessage {
  command?: string
  type?: string
}

export const channelAcceptedCommand = 'accepted'

const debug = false

export class SetupMessageChannel<T extends BaseChannelMessage> {
  private channel = new MessageChannel()
  private port1 = this.channel.port1
  private channelClosed = false
  channelReady = false

  constructor(
    private channelCounter: number,
    private iframe: HTMLIFrameElement,
    private initMessage: any,
    private channelReadyHandler: ChannelReadyHandler,
    private handleReceivedChannelMessage: ChannelMessageHandler<T>,
  ) {
    this.setupChannelMessaging()
  }

  private setupChannelMessaging() {
    if (debug) {
      console.log(`setting up channel messaging`, this.channelCounter)
    }
    this.port1.onmessage = (event) => {
      if (!this.channelClosed) {
        this.receivedChannelMessageMessageHandler(event.data)
      }
    }
    // todo remove the channel counter and do it also in the nextlab ChannelMessagingClient file
    const { ...initMessage } = this.initMessage
    initMessage.channelCounter = this.channelCounter
    this.iframe.contentWindow!.postMessage(initMessage, '*', [this.channel.port2])
    if (debug) {
      console.log(`sent init message`, this.channelCounter)
    }
  }

  private receivedChannelMessageMessageHandler(data: T) {
    if (data.command === channelAcceptedCommand || data.type === channelAcceptedCommand) {
      if (debug) {
        console.log(`channel ready`, this.channelCounter)
      }
      this.channelReady = true
      this.channelReadyHandler(this.port1)
    } else {
      this.handleReceivedChannelMessage(data)
    }
  }

  close() {
    this.channel.port1.close()
    this.channel.port2.close()
    this.channelClosed = true
  }
}
